import css from '@styled-system/css';
import styled from 'styled-components';
import { alignSelf, color, compose, space, typography, } from 'styled-system';
import theme from '../theme';
const Tag = styled.span `
  :hover {
    text-decoration-line: underline;
  }
  ${css({
    cursor: 'pointer',
    fontFamily: 'body',
    fontSize: '0',
    lineHeight: 'normal',
    fontWeight: 'bold',
    color: 'accent.3',
    marginRight: '3',
})}
  ${compose(alignSelf, color, space, typography)}
`;
Tag.defaultProps = { theme };
export default Tag;
//# sourceMappingURL=Tag.js.map